// extracted by mini-css-extract-plugin
export default {"container":"text__container__hb_1S","dedicatedPage":"text__dedicatedPage__Vs_uD","wrapper":"text__wrapper__X7Q5T","noBg":"text__noBg__srjgC","content":"text__content__ieM4D"};